import { request } from '@koi-design/vix-tools';
import { prefixApi } from './urls';

export interface LoginUrlRequest {
  corpId: string;
  redirectUri: string;
}

// 获取登录链接
export const getLoginUrlApi = async (params: LoginUrlRequest): Promise<string> => {
  return request({
    url: `${prefixApi}/wxAuth/getLoginUrl`,
    method: 'post',
    data: params
  });
};

export interface GetUserInfoRequest {
  corpId: string;
  code: string;
  userId?: string;
  agentId?: string;
  state?: string;
  authCode?: string;
}

// 获取员工信息
export const getUserInfoApi = async (params: GetUserInfoRequest): Promise<any> => {
  return request({
    url: `${prefixApi}/wxAuth/getUserInfo`,
    catchAll: true,
    method: 'post',
    data: params
  });
};
